var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown-divider',_vm._g(_vm._b({staticClass:"gl-dropdown-divider"},'b-dropdown-divider',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }